export default{
    setSearchingData(state, data) {
        state.searchingData.per_page = data.per_page
        state.searchingData.page = data.page
        state.searchingData.search = data.search
        state.searchingData.sort = data.sort
        state.searchingData.aggregate_day_range = data.aggregate_day_range
    },
    resetSearchingData(state, data){
        state.searchingData = {
            per_page: 10,
            page: 1,
            search: {
                user: '',
                log_category: '',
                log_level: '',
                log_id: '',
                datetime_start: this.$timeutil.getNowDatetime(),
                datetime_end: this.$timeutil.getPastDayDatetime(3)
            },
            sort: {
                key: 'datetime',
                asc: false
            },
            aggregate_day_range: 90
        }
    },
}